const unlockManageRouter = {
  path: "/unlock",
  name: "解锁管理",
  meta: { title: "解锁管理", icon: "el-icon-lock" },
  redirect: "/unlock/unlockGroup",
  component: () => import("../../views/unlockManage/index.vue"),
  children: [
    {
      path: "/unlock/unlockGroup",
      name: "解锁组",
      meta: {  title: "解锁组" },
      component: () => import("../../views/unlockManage/unlockGroup/index")
    },
    {
      path: "/unlock/unlockMode",
      name: "解锁方式",
      meta: {  title: "解锁方式" },
      component: () => import("../../views/unlockManage/unlockMode/index")
    }
  ]
};
export default unlockManageRouter;
